import React from 'react';
import {isEmbedSubdomain} from 'utils/mediafly/isEmbedded';
import SidebarTogglerContainer from 'components/stateful/search/SidebarTogglerContainer';
import Navigation from 'components/nav/Navigation';
import siteNav from 'components/nav/siteNav';
import UserDropdownContainer from 'components/stateful/UserDropdownContainer';
import {RouterLocation} from '@store/@types/util/ReactRouter';
import {CoachLogo} from '@components/logo/CoachLogo';
import cn from 'classnames';
import './DashboardNav.styl';
import './DashboardNav.mobile.sass';

interface DashboardNavProps {
  location: RouterLocation;
}

export const DashboardNav: React.FC<DashboardNavProps> = props => {
  return (
    <nav className={cn('navbar', 'dashboard-navbar', {embed: isEmbedSubdomain()})}>
      <div className="left">
        <SidebarTogglerContainer />
      </div>
      <CoachLogo />
      <Navigation location={props.location} links={siteNav} />
      {!isEmbedSubdomain() && (
        <div className="user-dropdown">
          <UserDropdownContainer />
        </div>
      )}
    </nav>
  );
};
